<template>
  <div>
    <div class="margin-bottom-8" v-if="$has('FWS-FWSGL-XZYHK')">
      <el-button :size="formSize" type="primary" @click="handleAddBank">新增</el-button>
    </div>
    <jr-table
      :loading="loading"
      :tableData="list"
      :tableColumn="tableColumn"
    >
      <template v-slot:accountNumber="{row, column}">
        <page-encrypt-icon
          :value.sync="row[`${column.prop}-new`]"
          :encryptValue="row.accountNumber"
        />
      </template>
      <template v-slot:status="{row}">
        <status
          type="dot"
          :color="row.status | statusFilter"
          :text="row.statusDesc || '-'"
        />
      </template>
    </jr-table>
    <!-- 新增银行卡 -->
    <add-bank-dialog
      :visible.sync="isBankShow"
      :businessName="businessName"
      :customerNo="customerNo"
      @success="init"
    />
  </div>
</template>

<script>
import { getCustomerBankcard } from '@/api/servicer';
import addBankDialog from './add-bank-dialog';

export default {
  name: 'BankInfo',
  props: {
    // 客户财务编号
    customerNo: {
      type: String,
    },
    businessName: {
      type: String,
      default: '',
    },
  },
  components: { addBankDialog },
  data() {
    return {
      loading: false,
      list: [],
      tableColumn: [
        { prop: 'accountTypeDesc', label: '卡类型', minWidth: '1' },
        { prop: 'accountName', label: '开户名', minWidth: '1' },
        { prop: 'accountNumber', label: '卡号', minWidth: '1', slotName: 'accountNumber' },
        { prop: 'bankName', label: '开户行', minWidth: '1' },
        { prop: 'branchName', label: '支行信息', minWidth: '1' },
        { label: '卡状态', status: 'status', slotName: 'status' },
      ],
      isBankShow: false,
    };
  },
  filters: {
    statusFilter(status) {
      // 1 正常 -1 异常
      const statusMap = {
        1: '#407DFF',
        '-1': '#FF3741',
      };
      return statusMap[status];
    },
  },
  methods: {
    init() {
      this.getInfo();
    },
    async getInfo() {
      try {
        this.loading = true;
        const res = await getCustomerBankcard({ customerNo: this.customerNo });
        this.loading = false;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
      }
    },
    handleAddBank() {
      this.isBankShow = true;
    },
  },
};
</script>
